import { Button, Grid } from "@mui/material";
import { CustomLink, EditFormControl } from "components";
import moment from "moment";
import { LoginForm } from "pages";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import userService from "services/user.service";
import { openLoading } from "store/reducers/tools";
import {
  curWeekNum,
  curYearNum,
  errorAction,
  formatArray,
  isNumberString,
  notify,
  serverPost,
  weeklyInfos,
} from "utility";

export const LoginComponent = () => {
  const history = useNavigate();
  const formRef = useRef();
  const dispatch = useDispatch();
  const [phoneCode, setPhoneCode] = useState("64");
  const [type, setType] = useState("email");
  const [data, setData] = useState({});
  const [remeCheck, setRemeCheck] = useState(false);
  const isAuth = useSelector((state) => state?.auth?.isAuth);
  const role = useSelector((state) => state?.auth?.user?.role ?? null);
  const remeInfo = useSelector((state) => state?.app?.remeCheck) ?? {};

  const handleSubmit = async () => {
    const submitData = formRef.current.prepare();
    if (submitData) {
      if (remeCheck)
        dispatch({
          type: "SET_APP",
          payload: { remeCheck: { remeCheck: remeCheck, userInfo: data } },
        });
      openLoading(true);
      userService.login({
        password: data?.password ?? "",
        verifyData:
          type === "email"
            ? data?.verifyData
            : `${phoneCode}${data?.verifyData ?? ""}`,
        onFinish: (res, err) => {
          openLoading(false);
          if (res === false) return errorAction(res, err);
          if (
            Boolean(res?.user?.role === "2") ||
            Boolean(res?.user?.role === "1")
          )
            handleFinish(res);
          else
            notify({
              variant: "warning",
              message: "Not Permission.",
            });
        },
      });
    }
  };

  const handleFinish = (value) => {
    dispatch({
      type: "SET_AUTH",
      payload: (s = {}) => ({
        ...(s ?? {}),
        user: value?.user ?? {},
        token: value?.token ?? "",
        jwt: value?.jwt ?? "",
      }),
    });
  };

  const handleChange = (newData) => {
    const { verifyData = "" } = newData;
    const typeFlag = isNumberString(verifyData);
    if (typeFlag && verifyData?.length > 1) setType("phone");
    else setType("email");
    setData(newData);
  };

  const loadData = () => {
    serverPost({
      url: "weeklySlot/all",
      data: {
        weekNum: curWeekNum,
        weekYear: curYearNum,
      },
      onFinish: (res, err) => {
        if (res === false) return;
        const day = moment().day();
        const dayData = formatArray(res)?.filter(
          (item) => item?.weekDay === day
        );
        dispatch({
          type: "SET_APP",
          payload: {
            selWeek: weeklyInfos[curWeekNum - 1],
            selDay: day - 1,
            label: day,
            boxes: dayData,
          },
        });
        history("/day-overview");
      },
    });
  };

  useEffect(() => {
    if (isAuth) {
      if (role === "2") history("/week-overview");
      else if (role === "1") loadData();
    }
    if (Boolean(remeInfo?.remeCheck)) {
      setData(remeInfo?.userInfo ?? {});
      setRemeCheck(true);
    }
    // eslint-disable-next-line
  }, [isAuth]);

  return (
    <div>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <LoginForm
            ref={formRef}
            phoneCode={phoneCode}
            data={data ?? {}}
            inputType={type}
            onChangePhoneCode={(newcode) => setPhoneCode(newcode)}
            onChange={handleChange}
            type="name-value"
          />
        </Grid>
        <Grid item>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <EditFormControl
                type="checkbox"
                name="remember_me"
                label="Remember me"
                value={remeCheck}
                onChange={(e) => setRemeCheck(e.target.value)}
              />
            </Grid>
            <Grid item>
              <CustomLink to="/forgot-password" color="primary">
                Forgot Password?
              </CustomLink>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Button
            onClick={handleSubmit}
            variant="contained"
            size="large"
            fullWidth
          >
            login
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
